import { ChangeDetectionStrategy, Component } from "@angular/core";
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";

/**
 * Confirmation dialog shown before a geofencing change (add, edit, or remove) that would
 * discard the currently displayed embeddings search results.
 */
@Component({
  selector: "app-geofencing-change-warning-dialog",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButton],
  template: `
    <h2 mat-dialog-title>Update geofencing</h2>
    <mat-dialog-content>
      <p>Changing the geofencing area will clear your current search results.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton [mat-dialog-close]="false">Cancel</button>
      <button matButton="filled" color="primary" [mat-dialog-close]="true">Continue</button>
    </mat-dialog-actions>
  `,
})
export class GeofencingChangeWarningDialogComponent {
  /**
   * Opens the confirmation dialog.
   * @param dialog MatDialog service to open the dialog with
   * @returns Dialog reference resolving to true if the user confirmed, false/undefined otherwise
   */
  static open(dialog: MatDialog): MatDialogRef<GeofencingChangeWarningDialogComponent, boolean> {
    return dialog.open(GeofencingChangeWarningDialogComponent, { width: "420px", autoFocus: false });
  }
}
